import { Modal } from "antd"
import { QuotationPolicy } from "src/common/models/quotation"
import { QuotationPolicyForm } from "./QuotationPolicyForm"
import { SystemDescriptions } from "src/common/descriptions"

interface Props {
    open: boolean
    onCancel?: () => void
    onAccept: (policyItem: QuotationPolicy) => void
    okText: string
    cancelText: string
    initialValues?: QuotationPolicy
}

export const QuotationPolicyModal = (props: Props) => {
    const descriptions = SystemDescriptions.PAGES.QUOTATION.CREATE

    const onFinish = (policyItem: QuotationPolicy) => {
        props.onAccept(policyItem)
    }

    return (
        <Modal
            title={descriptions.POLICY.FORM.TITLE}
            centered
            open={props.open}
            onCancel={props.onCancel}
            width={1000}
            okText={props.okText}
            cancelText={props.cancelText}
            footer={<></>}
            closable={false}
            zIndex={1200}
            getContainer={false}
        >
            <QuotationPolicyForm
                onFinish={onFinish}
                onCancel={function (): void {
                    props.onCancel && props.onCancel()
                }}
                initialValues={props.initialValues}
            />
        </Modal>
    )
}
